/* Bazaar Bee homepage v3: banner slider (progress bars), delivery dates, pack chips, quick order, sticky bar, reels, recently viewed */
(() => {
  if (window.BBH) return;
  window.BBH = true;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d; };
  const fmt = (d, month) => `${d.toLocaleDateString('en-IN', { weekday: 'short' })} ${d.getDate()}` + (month ? ' ' + d.toLocaleDateString('en-IN', { month: 'short' }) : '');
  const money = (cents) => '₹' + Math.round(cents / 100).toLocaleString('en-IN');

  async function add(id, qty) {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] }),
    });
    if (!res.ok) throw new Error(String(res.status));
  }
  // "Order now": set this item's quantity (cart/update adds it when missing), so ordering twice never doubles it
  async function setQty(id, qty) {
    const res = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: { [Number(id)]: Number(qty) || 1 } }),
    });
    if (!res.ok) throw new Error(String(res.status));
  }
  async function refreshBubble() {
    try {
      const cart = await (await fetch(`${root}cart.js`)).json();
      document.querySelectorAll('cart-icon').forEach((el) => el.renderCartBubble && el.renderCartBubble(cart.item_count));
    } catch (e) {}
  }

  function dates() {
    document.querySelectorAll('[data-bbh-eta]').forEach((el) => {
      const a = +el.dataset.min, b = +el.dataset.max;
      if (a && b) el.textContent = `${fmt(inDays(a))} – ${fmt(inDays(b), true)}`;
    });
    document.querySelectorAll('[data-bbh-eta-end]').forEach((el) => {
      const b = +el.dataset.max;
      if (b) el.textContent = fmt(inDays(b), true);
    });
    const d0 = new Date(); d0.setHours(0, 0, 0, 0);
    document.querySelectorAll('[data-bbh-days-to]').forEach((el) => {
      const t = new Date(el.dataset.bbhDaysTo + 'T00:00:00');
      if (!isNaN(t)) el.textContent = Math.max(0, Math.round((t - d0) / 864e5));
    });
    document.querySelectorAll('[data-bbh-hide-after]').forEach((el) => {
      const t = new Date(el.dataset.bbhHideAfter + 'T23:59:59');
      if (!isNaN(t) && new Date() > t) el.hidden = true;
    });
  }
  function countdown() {
    const n = new Date(), m = new Date(n); m.setHours(24, 0, 0, 0);
    const s = Math.floor((m - n) / 1000);
    const txt = Math.floor(s / 3600) + 'h ' + String(Math.floor((s % 3600) / 60)).padStart(2, '0') + 'm';
    document.querySelectorAll('[data-bbh-cd]').forEach((el) => (el.textContent = txt));
  }

  function slider(hero) {
    const track = hero.querySelector('.bbh-track');
    const bars = hero.querySelector('.bbh-bars');
    let slides = [], i = 0;
    const go = (n) => {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      track.style.transform = `translateX(-${i * 100}%)`;
      slides.forEach((s, k) => s.classList.toggle('is-on', k === i));
      [...bars.children].forEach((b, k) => (b.className = k < i ? 'is-done' : ''));
      const cur = bars.children[i];
      if (cur && !reduced) { void cur.offsetWidth; cur.className = 'is-run'; }
    };
    const build = () => {
      slides = [...track.children].filter((s) => !s.hidden && getComputedStyle(s).display !== 'none');
      bars.innerHTML = slides.length > 1 ? slides.map((_, k) => `<button type="button" aria-label="Slide ${k + 1}"><i></i></button>`).join('') : '';
      [...bars.children].forEach((b, k) => b.addEventListener('click', () => go(k)));
      go(Math.min(i, Math.max(slides.length - 1, 0)));
    };
    bars.addEventListener('animationend', () => go(i + 1));
    hero.querySelector('.bbh-prev')?.addEventListener('click', () => go(i - 1));
    hero.querySelector('.bbh-next')?.addEventListener('click', () => go(i + 1));
    let x0 = null;
    hero.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; hero.classList.add('is-hold'); }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      hero.classList.remove('is-hold');
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    let w = hero.clientWidth;
    window.addEventListener('resize', () => { if (Math.abs(hero.clientWidth - w) > 1) { w = hero.clientWidth; build(); } });
    build();
  }

  function sticky(bar) {
    const cta = bar.closest('[data-bbh-deal]')?.querySelector('.bbh-deal__cta');
    if (!cta) return;
    const check = () => {
      const r = cta.getBoundingClientRect();
      bar.hidden = r.bottom > 0 && r.top < window.innerHeight;
    };
    document.addEventListener('scroll', check, { capture: true, passive: true });
    window.addEventListener('resize', check);
    check();
  }

  function reels(list) {
    const vids = list.querySelectorAll('video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      const v = en.target, card = v.closest('.bbh-reel');
      if (en.isIntersecting && !reduced) { v.muted = true; v.play().then(() => card.classList.add('is-playing')).catch(() => {}); }
      else { v.pause(); card.classList.remove('is-playing'); }
    }), { threshold: 0.6 });
    vids.forEach((v) => io.observe(v));
  }

  async function recent(sec) {
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem('bb_recent') || '[]'); } catch (e) {}
    if (!handles.length) return;
    const box = sec.querySelector('[data-bbh-recent-list]');
    const d = sec.dataset;
    const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const eta = +d.etaMin && +d.etaMax ? `${fmt(inDays(+d.etaMin))} – ${fmt(inDays(+d.etaMax), true)}` : '';
    const items = await Promise.all(handles.slice(0, 8).map((h) =>
      fetch(`${root}products/${encodeURIComponent(h)}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)));
    const cards = items.filter((p) => p && p.available).map((p) => {
      const v = p.variants.find((x) => x.available) || p.variants[0];
      const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=360` : '';
      let badge = '';
      if (d.badgeTag && (p.tags || []).includes(d.badgeTag)) badge = d.badgeText;
      else if (p.compare_at_price > p.price) badge = `SAVE ${Math.round(((p.compare_at_price - p.price) * 100) / p.compare_at_price)}%`;
      return `<div class="bbh-rv__card">
        <a class="bbh-rv__im" href="${p.url}">${img ? `<img src="${img}" alt="${esc(p.title)}" loading="lazy" width="170" height="170">` : ''}${badge ? `<span class="bbh-rv__bd">${esc(badge)}</span>` : ''}</a>
        <div class="bbh-rv__tx">
          <a class="bbh-rv__nm" href="${p.url}">${esc(p.title)}</a>
          <div class="bbh-rv__pr"><b>${money(p.price)}</b><span class="bbh-rv__cod">✅ COD</span></div>
          ${eta ? `<div class="bbh-rv__eta">🚚 Get it by <b>${eta}</b></div>` : ''}
          <div class="bbh-rv__row"><button type="button" class="bbh-rv__go" data-bbh-order data-variant="${v.id}" data-qty="1">${esc(d.cta)} <i>➜</i></button><a class="bbh-rv__vw" href="${p.url}">${esc(d.view)}</a></div>
        </div>
      </div>`;
    });
    if (!cards.length) return;
    box.innerHTML = cards.join('');
    if (cards.length > 1) {
      sec.querySelector('.bbh-rv__one').hidden = true;
      sec.querySelector('.bbh-rv__many').hidden = false;
    }
    sec.hidden = false;
  }

  document.addEventListener('click', async (e) => {
    const order = e.target.closest('[data-bbh-order]');
    if (order) {
      e.preventDefault();
      order.disabled = true;
      try { await setQty(order.dataset.variant, order.dataset.qty); if (window.bbCheckout) { order.disabled = false; window.bbCheckout(); } else window.location.href = `${root}checkout`; } // bbCheckout: our COD form
      catch (err) { order.disabled = false; alert('Sorry, this item could not be added. Please try again.'); }
      return;
    }
    const plus = e.target.closest('[data-bbh-add]');
    if (plus) {
      e.preventDefault();
      if (plus.disabled) return;
      plus.disabled = true;
      const label = plus.innerHTML;
      try {
        await add(plus.dataset.variant, 1);
        plus.classList.add('is-added'); plus.textContent = '✓';
        refreshBubble();
        document.dispatchEvent(new CustomEvent('bb:cart:added'));
      } catch (err) { alert('Sorry, this item could not be added. Please try again.'); }
      setTimeout(() => { plus.classList.remove('is-added'); plus.innerHTML = label; plus.disabled = false; }, 1800);
      return;
    }
    const chip = e.target.closest('[data-bbh-chip]');
    if (chip) {
      const deal = chip.closest('[data-bbh-deal]');
      deal.querySelectorAll('[data-bbh-chip]').forEach((c) => { c.classList.toggle('is-on', c === chip); c.setAttribute('aria-pressed', c === chip); });
      deal.querySelectorAll('[data-bbh-order]').forEach((b) => (b.dataset.qty = chip.dataset.qty));
      deal.querySelectorAll('[data-bbh-price]').forEach((p) => (p.textContent = chip.dataset.price));
      const st = deal.querySelector('[data-bbh-sticky-t]');
      if (st) st.textContent = chip.dataset.sticky;
    }
  });

  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-bbh-track]');
    if (!f) return;
    e.preventDefault();
    const v = (f.querySelector('input').value || '').trim().replace(/^#/, '');
    const base = f.dataset.url;
    window.location.href = base && v ? base + encodeURIComponent(v) : (base || `${root}account`);
  });

  const init = () => {
    dates(); countdown(); setInterval(countdown, 30000);
    document.querySelectorAll('[data-bbh-slider]').forEach(slider);
    document.querySelectorAll('[data-bbh-sticky]').forEach(sticky);
    document.querySelectorAll('[data-bbh-reels]').forEach(reels);
    document.querySelectorAll('[data-bbh-recent]').forEach(recent);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
